export default [
    {
        path: "contracts",
        alias: "sutartys",
        component: () =>
            import(
                /* webpackChunkName: "ContractsWrapper" */ "@/views/Contracts/ContractsWrapper.vue"
            ),
        meta: {
            layout: "Default",
        },
        children: [
            {
                path: "",
                name: "contracts_index",
                meta: {
                    title: "Contracts",
                    pageContentHeaderComponent: () =>
                        import("@/components/Contracts/CreateNewContractButton.vue"),
                },
                component: () =>
                    import(
                        /* webpackChunkName: "Contracts" */ "@/views/Contracts/Contracts.vue"
                    ),
            },
            {
                path: "new",
                name: "contracts_new",
                meta: {
                    title: "Contracts",
                    pageContentHeaderComponent: () =>
                        import("@/components/Contracts/CreateNewContractButton.vue"),
                },
                component: () =>
                    import(
                        /* webpackChunkName: "NewContract" */ "@/views/Contracts/NewContract.vue"
                    ),
            },
            {
                path: ":uuid",
                name: "user_contract_index",
                meta: {
                    breadcrumbs: ["contracts_index"],
                    hideTitle: true,
                },
                component: () =>
                    import(
                        /* webpackChunkName: "UserContract" */ "@/views/Contracts/UserContract/UserContract.vue"
                    ),
            },
            // {
            //     path: ":uuid/edit",
            //     name: "user_contract_edit",
            //     meta: {
            //         breadcrumbs: ["user_contract_index"],
            //         hideTitle: true,
            //         layout: "Generation",
            //         sideMenuComponent: () =>
            //             import(
            //                 "@/components/Contracts/ContractGeneration/QuestionSteps.vue"
            //                 ),
            //     },
            //     component: () =>
            //         import(
            //             /* webpackChunkName: "FillContract" */ "@/views/Contracts/UserContract/FillContract.vue"
            //         ),
            // },
        ],
    },
    // {
    //     path: "contracts",
    //     alias: "sutartys",
    //     component: () =>
    //         import(
    //             /* webpackChunkName: "ContractsWrapper" */ "@/views/Contracts/ContractsWrapper.vue"
    //         ),
    //     meta: {
    //         layout: "Default",
    //     },
    //     children: [
    //         {
    //             path: "",
    //             name: "contracts_index",
    //             meta: {
    //                 title: "Contracts",
    //             },
    //             component: () =>
    //                 import(
    //                     /* webpackChunkName: "Contracts" */ "@/views/Contracts/Contracts.vue"
    //                 ),
    //         },
    //         {
    //             path: ":slug",
    //             name: "contract_index",
    //             meta: {
    //                 breadcrumbs: ["contracts_index"],
    //                 hideTitle: true,
    //             },
    //             component: () =>
    //                 import(
    //                     /* webpackChunkName: "Contract" */ "@/views/Contracts/Contract.vue"
    //                 ),
    //         },
    //         {
    //             path: ":slug/fill",
    //             name: "contract_fill",
    //             meta: {
    //                 breadcrumbs: ["contracts_index", "contract_index"],
    //                 hideTitle: true,
    //                 layout: "Generation",
    //                 sideMenuComponent: () =>
    //                     import(
    //                         "@/components/Contracts/ContractGeneration/QuestionSteps.vue"
    //                         ),
    //             },
    //             component: () =>
    //                 import(
    //                     /* webpackChunkName: "FillContract" */ "@/views/Contracts/FillContract.vue"
    //                 ),
    //         },
    //     ],
    // },
];
